import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './assets/fonts/Jablo-Thin.ttf'
import './assets/fonts/Jablo-Regular.ttf'
import './assets/fonts/Jablo-RegularUltraCondensed.ttf'
import './assets/fonts/Jablo-Semibold.ttf'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
// StrictMode turned off with React18 for rerendering issues
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
